import axios from "axios";
import * as yup from "yup";
import {buildQuery} from "utils/queryUtils";

let schema = yup.object().shape({
    code: yup.string().test("not-blank", "code.required", (code) => code?.length > 0),
    name: yup.string().test("not-blank", "name.required", (name) => name?.length > 0),
});

export const validateRole = (role) => {
    return schema.validate(role, {abortEarly: false});
};

export const findRoles = (headers, params) => {
    let query = buildQuery(params, ["code", "name"]);
    return axios.get(`${process.env.REACT_APP_IDP_API_URL}/roles${query}`, {
        headers
    })
}

export const createRole = (headers, data) => {
    return axios.post(`${process.env.REACT_APP_IDP_API_URL}/roles`, data, {
        headers
    })
}

export const updateRole = (headers, id, data) => {
    return axios.patch(`${process.env.REACT_APP_IDP_API_URL}/roles/${id}`, data, {
        headers
    })
}

export const updatePrivileges = (headers, id, data) => {
    return axios.post(`${process.env.REACT_APP_IDP_API_URL}/roles/${id}/privileges`, data, {
        headers
    })
}

export const deleteRole = (headers, id) => {
    return axios.delete(`${process.env.REACT_APP_IDP_API_URL}/roles/${id}`, {
        headers: headers,
    });
}

export const deleteRoles = (headers, ids) => {
    return axios.delete(`${process.env.REACT_APP_IDP_API_URL}/roles?id=${ids.join()}`, {
        headers: headers,
    });
}
